import { render } from "./preloader.vue?vue&type=template&id=94e57382"
import script from "./preloader.vue?vue&type=script&lang=js"
export * from "./preloader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekomini/.gitlab-runner/builds/pUzgx6Vs/0/neko_client_projects/shojo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__